import React, { useState, useEffect } from "react";
import { useForm, useWatch } from "react-hook-form";
import { useNavigate, useLocation } from "react-router-dom";
import { Button } from "react-bootstrap";
import { yupResolver } from "@hookform/resolvers/yup";
import { toast } from "react-toastify";
import cloneDeep from "lodash/cloneDeep";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import FormHandler from "../Common/Form/FormHandler/FormHandler";
import {
  createevent,
  getincidentcatcreate,
  getincidentFilteredDatain,
  getMasterResourceByIdURL,
  getThemeURL,
  resourceCatListURL,
  updateincident,
} from "../../../Services/EndPoints";
import { setRegFilesToStore } from "../../../CentralStore/RegistrationsSlice/registrationSlice";
import {
  getData,
  postDataWithBody,
  postDataWithBodyEvent,
} from "../../../Services/Services";
import {
  EventResourceConfig,
} from "../../../JsonData/EventResourceConfig";
import EventMap from "../RegionManagement/RMMap/EventMap";
import * as yup from "yup";

const CreateEventFormPage = () => {
  console.log("🚀 CreateEventFormPage component mounted");

  const [masterresourceConfig, setMasterResourceConfig] =
    useState(EventResourceConfig);
    // eslint-disable-next-line no-unused-vars
  const [resourceCategoriesList, setResourceCategoriesList] = useState([]);
  const [loader, setLoader] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [masterCategory, setMasterCategory] = useState(null);
  const navigate = useNavigate();
  // eslint-disable-next-line no-unused-vars
  const [activeTab, setActiveTab] = useState(0);
  const [clickedPoint, setClickedPoint] = useState(null);
  const { t } = useTranslation();
  const { state } = useLocation();
  const dispatch = useDispatch();
  let id = state?.id;
  let edit = state?.edit;
  let imgName = state?.imgName;

  console.log("📍 Location state:", { id, edit, imgName });
// eslint-disable-next-line no-unused-vars
  const [selectedIncidentInfo, setSelectedIncidentInfo] = useState(null);
  const [incidentCreationDate, setIncidentCreationDate] = useState(null);

  // Dynamic validation schema
  const getValidationSchema = () => {
    console.log(
      "🔄 Generating validation schema with incidentCreationDate:",
      incidentCreationDate
    );

    return [
      yup.object({
        incidentname: yup.string().required("Please select an incident"),
        eventdatetime: yup
          .string()
          .required("Event date/time is required")
          .test(
            "is-not-future",
            "Event date/time cannot be in the future",
            function (value) {
              console.log("🔍 Validating future date:", value);
              if (!value) {
                console.log("❌ No event date provided");
                return false;
              }
              const selectedDate = new Date(value);
              const now = new Date();
              const isValid = selectedDate <= now;
              console.log(
                "📅 Future validation result:",
                isValid,
                "Selected:",
                selectedDate,
                "Now:",
                now
              );
              return isValid;
            }
          )
          .test(
            "is-after-incident-creation",
            "Event Date and Time cannot be earlier than incident creation date",
            function (value) {
              console.log(
                "🔍 Validating against incident creation date:",
                value
              );

              if (!value) {
                console.log(
                  "❌ No event date provided for incident validation"
                );
                return false;
              }

              const { incidentname } = this.parent;
              console.log("📋 Current incident name from form:", incidentname);

              if (!incidentname) {
                console.log(
                  "ℹ️ No incident selected, skipping incident date validation"
                );
                return true;
              }

              const selectedIncident = IncidentsData.find((incident) => {
                const match = incident.id === parseInt(incidentname);
                console.log(
                  "🔍 Checking incident:",
                  incident.id,
                  "against:",
                  incidentname,
                  "Match:",
                  match
                );
                return match;
              });

              console.log("📊 Selected incident found:", selectedIncident);

              if (!selectedIncident || !selectedIncident.created_on) {
                console.log(
                  "ℹ️ No incident creation date found, skipping validation"
                );
                return true;
              }

              const eventDate = new Date(value);
              const incidentCreationDate = new Date(
                selectedIncident.created_on
              );

              console.log(
                "📅 Date comparison - Event:",
                eventDate,
                "Incident Creation:",
                incidentCreationDate
              );
              console.log(
                "⏰ Event timestamp:",
                eventDate.getTime(),
                "Incident timestamp:",
                incidentCreationDate.getTime()
              );

              const isValid = eventDate >= incidentCreationDate;
              console.log("✅ Incident date validation result:", isValid);

              if (!isValid) {
                console.log(
                  "❌ Validation failed: Event date is before incident creation date"
                );
                console.log(
                  "📝 Incident created on:",
                  incidentCreationDate.toLocaleString()
                );
                console.log(
                  "📝 Event scheduled for:",
                  eventDate.toLocaleString()
                );
              }

              return isValid;
            }
          ),
        eventDes: yup
          .string()
          .max(250, "Event description must be at most 250 characters")
          .test(
            "length-check",
            "Event description must be at most 250 characters",
            function (value) {
              const isValid = !value || value.length <= 250;
              console.log(
                "📝 Event description validation:",
                isValid,
                "Length:",
                value?.length
              );
              return isValid;
            }
          ),
      }),
    ];
  };

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    getValues,
    reset,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(getValidationSchema()[activeTab]),
    mode: "all",
  });

  // Safe error logging function
  const getSafeErrors = () => {
    const safeErrors = {};
    Object.keys(errors).forEach((key) => {
      if (errors[key]) {
        safeErrors[key] = {
          message: errors[key]?.message,
          type: errors[key]?.type,
        };
      }
    });
    return safeErrors;
  };

  console.log("📋 Form errors:", getSafeErrors());
  console.log("📋 Form values:", getValues());
// eslint-disable-next-line no-unused-vars
  const [showPopup, setShowPopup] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [districtId, setDistrictId] = useState("");
  // eslint-disable-next-line no-unused-vars
  const [selectedDistrictIds, setSelectedDistrictIds] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [selectedRegions, setSelectedRegions] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [selectedBlockIds, setSelectedBlockIds] = useState([]);
  const [selectedPanchayatIds, setSelectedPanchayatIds] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [selectedVillageIds, setSelectedVillageIds] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [isLoading, setIsLoading] = useState(false);
  const [coordinates, setCoordinates] = useState({
    latitude: null,
    longitude: null,
  });
  const [username, setusername] = useState("");
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [filePreviews, setFilePreviews] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [IncidentsData, setIncidentsData] = useState([]);

  console.log("📊 IncidentsData state:", IncidentsData);
  console.log("📍 Current coordinates:", coordinates);
  console.log("📎 Selected files:", selectedFiles);
  console.log("👤 Username:", username);

  const handleShow = () => setShowPopup(true);

  // Watch for incident name changes
  const currentIncidentId = watch("incidentname");
  console.log("🎯 Current incident ID from form:", currentIncidentId);

  useEffect(() => {
    console.log(
      "🔄 useEffect triggered - currentIncidentId changed:",
      currentIncidentId
    );

    if (currentIncidentId) {
      console.log(
        "📡 Fetching region details for incident:",
        currentIncidentId
      );
      getregiondetails(currentIncidentId);

      // Also get the incident creation date for validation and display
      const selectedIncident = IncidentsData.find((incident) => {
        const match = incident.id === parseInt(currentIncidentId);
        console.log(
          "🔍 Finding incident in IncidentsData:",
          incident.id,
          "===",
          currentIncidentId,
          "Match:",
          match
        );
        return match;
      });

      console.log("📋 Selected incident found:", selectedIncident);

      if (selectedIncident && selectedIncident.created_on) {
        const creationDate = new Date(selectedIncident.created_on);
        setIncidentCreationDate(creationDate);
        setSelectedIncidentInfo(selectedIncident);
        console.log(
          "📅 Incident creation date set:",
          creationDate.toLocaleString()
        );
        console.log("📋 Selected incident info set:", selectedIncident);
      } else {
        setIncidentCreationDate(null);
        setSelectedIncidentInfo(null);
        console.log("❌ No incident creation date found or incident not found");
      }
    } else {
      setIncidentCreationDate(null);
      setSelectedIncidentInfo(null);
      console.log("ℹ️ No incident selected, cleared incident date and info");
    }
  }, [currentIncidentId, IncidentsData]);

  const getregiondetails = async (id) => {
    console.log("🗺️ Getting region details for incident ID:", id);
    try {
      const ince_region = await postDataWithBody(updateincident, [id], {});
      console.log("📍 Region details response:", ince_region);
      setSelectedPanchayatIds([]);
      if (ince_region?.regions?.length > 0) {
        const panchayatIds = ince_region.regions
          .map((region) => region.gis_id)
          .filter((gis_id) => gis_id !== null);

        console.log("🏘️ Panchayat IDs extracted:", panchayatIds);
        setSelectedPanchayatIds(panchayatIds);
      } else {
        console.log("ℹ️ No regions found for this incident");
      }
    } catch (error) {
      console.error("❌ Error fetching region details:", error);
      setSelectedPanchayatIds([]);
    }
  };

  const handleLocationSelect = (coords) => {
    console.log("📍 Location selected on map:", coords);
    setCoordinates(coords);
    // Update form values
    setValue("latitude", coords.latitude);
    setValue("longitude", coords.longitude);
    console.log("📝 Form values updated with coordinates");
  };

  // File upload handler
  const handleFileChange = (e) => {
    console.log("📁 File input changed, files:", e.target.files);
    const files = Array.from(e.target.files);

    // Filter only image and video files
    const mediaFiles = files.filter(
      (file) => file.type.startsWith("image/") || file.type.startsWith("video/")
    );

    console.log("🖼️ Media files filtered:", mediaFiles);

    if (mediaFiles.length > 0) {
      setSelectedFiles(mediaFiles);
      console.log("✅ Selected files updated:", mediaFiles);

      // Create previews for media files
      const previews = [];
      mediaFiles.forEach((file) => {
        const reader = new FileReader();
        reader.onload = (event) => {
          previews.push({
            url: event.target.result,
            type: file.type.startsWith("image/") ? "image" : "video",
          });
          console.log("🖼️ File preview created:", file.name, file.type);
          if (previews.length === mediaFiles.length) {
            setFilePreviews(previews);
            console.log("🎬 All file previews set:", previews);
          }
        };
        reader.readAsDataURL(file);
      });
    } else {
      console.log("❌ No valid media files selected");
    }
  };

//   const filesToByteArrays = async (files) => {
//     console.log("🔢 Converting files to byte arrays:", files);
//     const byteArrays = [];
//     for (const file of files) {
//       const byteArray = await new Promise((resolve, reject) => {
//         const reader = new FileReader();
//         reader.onload = (event) => {
//           const arrayBuffer = event.target.result;
//           const byteArray = new Uint8Array(arrayBuffer);
//           console.log(
//             "📊 File converted to byte array:",
//             file.name,
//             "Size:",
//             byteArray.length
//           );
//           resolve(Array.from(byteArray));
//         };
//         reader.onerror = (error) => {
//           console.error("❌ Error converting file to byte array:", error);
//           reject(error);
//         };
//         reader.readAsArrayBuffer(file);
//       });
//       byteArrays.push({
//         name: file.name,
//         type: file.type,
//         data: byteArray,
//       });
//     }
//     console.log("✅ All files converted to byte arrays");
//     return byteArrays;
//   };

  useEffect(() => {
    console.log("👤 Fetching user data on component mount");
    getUserdataprof();
  }, []);

  const getUserdataprof = async () => {
    try {
      console.log("📡 Fetching user profile data...");
      const usr_prof = await getData(getThemeURL);
      console.log("👤 User profile data received:", usr_prof);
      setusername(usr_prof[0].user_name);
      console.log("✅ Username set to:", usr_prof[0].user_name);
    } catch (error) {
      console.error("❌ Error fetching user data:", error);
    }
  };

  useEffect(() => {
    if (imgName) {
      console.log("🖼️ Setting image name from props:", imgName);
      setValue("resource_image_name", imgName);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [imgName, setValue]);

  const rscractivity = useWatch({
    control,
    name: "activity",
  });

  useEffect(() => {
    console.log("🔄 Initializing form data");
    getInitFormData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [t]);

  useEffect(() => {
    console.log("📡 Fetching incidents list on component mount");
    getincidentslist();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const rscractivity = getValues("activity");
    console.log("🔄 Activity changed:", rscractivity);
    if (rscractivity && rscractivity !== "") {
      console.log("📡 Fetching categories for activity:", rscractivity);
      getCategoryByActivity(rscractivity);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rscractivity]);

  const getInitFormData = async () => {
    console.log("🔄 Initializing form data...");
    setLoader(true);
    await getActivityList();
    setLoader(false);
    console.log("✅ Form data initialization complete");
  };

  async function getincidentslist() {
    console.log("📡 Fetching incidents list...");
    setLoader(true);

    let masterResourceList = await getData(getincidentcatcreate);
    console.log("📋 Raw incidents data received:", masterResourceList);

    let sortedList = masterResourceList.sort((a, b) => {
      const dateA = new Date(a.created_on);
      const dateB = new Date(b.created_on);
      const result = dateB - dateA;
      console.log(
        `📅 Sorting: ${a.id} (${dateA}) vs ${b.id} (${dateB}) = ${result}`
      );
      return result;
    });

    console.log("📊 Sorted incidents list:", sortedList);
    setLoader(false);

    setIncidentsData(sortedList);
    console.log("✅ Incidents data set in state");
  }

  const getActivityList = async () => {
    try {
      console.log("📡 Fetching incident data for dropdown...");
      const incidentData = await getData(getincidentFilteredDatain);
      console.log("📋 Incident dropdown data received:", incidentData);

      const incidentList = Array.isArray(incidentData) ? incidentData : [];
      const options = incidentList.map((item) => ({
        value: item.id || item.value || "",
        label: item.name || item.label || "Unnamed Incident",
      }));

      console.log("📝 Dropdown options generated:", options);

      const updatedConfig = cloneDeep(EventResourceConfig);
      updatedConfig[0].fields[0].options = [
        { label: t("masterresourceplaceholder.select"), value: "" },
        ...options,
      ];

      setMasterResourceConfig(updatedConfig);
      console.log("✅ Master resource config updated with incident options");
    } catch (error) {
      console.error("❌ Error fetching incident data:", error);
      const updatedConfig = cloneDeep(EventResourceConfig);
      updatedConfig[0].fields[0].options = [
        { label: t("masterresourceplaceholder.select"), value: "" },
      ];
      setMasterResourceConfig(updatedConfig);
      console.log("⚠️ Using default config due to error");
    }
  };

  const getCategoryByActivity = async (activity) => {
    console.log("📡 Fetching categories for activity:", activity);
    if (activity !== "") {
      var resourceCategoryList = await getData(resourceCatListURL + activity);
      console.log("📋 Resource categories received:", resourceCategoryList);

      for (let resourceCat in resourceCategoryList) {
        resourceCategoryList[resourceCat]["label"] =
          resourceCategoryList[resourceCat]["category"];
        resourceCategoryList[resourceCat]["value"] =
          resourceCategoryList[resourceCat]["category"];
      }
      masterresourceConfig[0].fields[1]["options"] = [
        { label: t("masterresourceplaceholder.select"), value: "" },
      ].concat(resourceCategoryList);
    } else {
      masterresourceConfig[0].fields[1]["options"] = [
        { label: t("masterresourceplaceholder.select"), value: "" },
      ];
      setMasterResourceConfig(masterresourceConfig);
    }
    setMasterResourceConfig(masterresourceConfig);
    setResourceCategoriesList(resourceCategoryList);
    console.log("✅ Categories updated for activity:", activity);

    if (id) {
      console.log("🔄 Editing existing resource, fetching details...");
      await getMasterResourceList();
    }
  };

  async function getMasterResourceList() {
    console.log("📡 Fetching master resource details for ID:", id);
    let masterResourceList = await postDataWithBody(
      getMasterResourceByIdURL,
      [id],
      {}
    );
    console.log("📋 Master resource details received:", masterResourceList);
    masterResourceList = masterResourceList[0];
    reset(masterResourceList);
    setMasterCategory(masterResourceList.category);
    console.log("✅ Master resource form populated");
  }

  const GenerateForm = (fields, register, errors, control) => {
    console.log("🔄 Generating form with fields:", fields);
    return (
      <div>
        <FormHandler
          register={register}
          errors={errors}
          fields={fields}
          control={control}
          setValue={setValue}
          columns={2}
          getValues={getValues}
          imgName={imgName}
          handleShow={handleShow}
          handleFileChange={handleFileChange}
          filePreviews={filePreviews}
          multiple
          uploadfilewidth={true}
        />
      </div>
    );
  };

  const generateTabsData = (tabWiseData) => {
    console.log("🔄 Generating tabs data:", tabWiseData);
    tabWiseData?.forEach((element) => {
      return (element.component = GenerateForm(
        element?.fields,
        register,
        errors,
        control
      ));
    });
    console.log("✅ Tabs data generated");
    return tabWiseData;
  };

  const submitHandler = async (data, e) => {
    e.preventDefault();
    console.log("🚀 Form submission started");
    console.log("📋 Form data to submit:", data);
    console.log("📎 Selected files count:", selectedFiles.length);

    setLoader(true);
    setIsSubmitting(true);

    // Validate event date against incident creation date manually
    if (data.incidentname && data.eventdatetime) {
      const selectedIncident = IncidentsData.find(
        (incident) => incident.id === parseInt(data.incidentname)
      );

      if (selectedIncident && selectedIncident.created_on) {
        const eventDate = new Date(data.eventdatetime);
        const incidentCreationDate = new Date(selectedIncident.created_on);

        console.log("🔍 Manual date validation check:");
        console.log("📅 Event date:", eventDate.toLocaleString());
        console.log(
          "📅 Incident creation date:",
          incidentCreationDate.toLocaleString()
        );
        console.log("⏰ Event timestamp:", eventDate.getTime());
        console.log("⏰ Incident timestamp:", incidentCreationDate.getTime());

        if (eventDate < incidentCreationDate) {
          console.log(
            "❌ Manual validation failed: Event date is before incident creation"
          );
          toast.error(
            "Event Date and Time cannot be earlier than incident creation date",
            {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 2000,
            }
          );
          setLoader(false);
          setIsSubmitting(false);
          return;
        }
      }
    }

    // Format date
    const dateObj = new Date(data.eventdatetime);
    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    const day = String(dateObj.getDate()).padStart(2, "0");
    let hours = dateObj.getHours();
    const minutes = String(dateObj.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    const paddedHours = String(hours).padStart(2, "0");
    const formatted = `${year}/${month}/${day} ${paddedHours}:${minutes} ${ampm}`;

    console.log("📅 Formatted date for submission:", formatted);

    try {
      // Prepare FormData
      const formData = new FormData();
      formData.append("createdBy", username);
      formData.append("incidentId", parseInt(data.incidentname));
      formData.append("lat", data.latitude);
      formData.append("lng", data.longitude);
      formData.append("time", formatted);
      formData.append("action", data.eventDes);
      formData.append("status", "OPEN");

      console.log("📦 FormData contents:");
      console.log("👤 createdBy:", username);
      console.log("🚨 incidentId:", parseInt(data.incidentname));
      console.log("📍 lat:", data.latitude);
      console.log("📍 lng:", data.longitude);
      console.log("⏰ time:", formatted);
      console.log("📝 action:", data.eventDes);
      console.log("📊 status: OPEN");

      if (selectedFiles.length > 0) {
        selectedFiles.forEach((file) => {
          formData.append("files", file);
          console.log("📎 Appended file:", file.name, file.type, file.size);
        });
      } else {
        console.log("ℹ️ No files to append");
      }

      console.log("📡 Sending request to create event...");
      // Use postDataWithBody with FormData (no headers override)
      const res = await postDataWithBodyEvent(createevent, formData);
      console.log("✅ Server response received:", res);

      if (res.message === "Event Created Successfully") {
        console.log("🎉 Event created successfully");
        toast.success(res.message, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });

        console.log("➡️ Navigating to incident management page");
        navigate("/situation-awareness/incident-management");
        dispatch(setRegFilesToStore({ type: "reset" }));
      } else {
        console.log("❌ Event creation failed:", res.message);
        toast.error(res.message || "Failed to create event", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });
        setIsSubmitting(false);
      }
    } catch (error) {
      console.error("❌ Submission error:", error);
      toast.error("An error occurred during submission", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
      setIsSubmitting(false);
    } finally {
      console.log("🏁 Submission process completed");
      setLoader(false);
      setIsSubmitting(false);
    }
  };

  const tabsData = generateTabsData(masterresourceConfig);
  console.log("📊 Final tabs data:", tabsData);

  return (
    <>
      <EventMap
        selectedRegions={selectedRegions}
        selectedDistrictIds={selectedDistrictIds}
        selectedBlockIds={selectedBlockIds}
        selectedPanchayatIds={selectedPanchayatIds}
        selectedVillageIds={selectedVillageIds}
        selectedDistrictId={districtId}
        isLoading={isLoading}
        onLocationSelect={handleLocationSelect}
        clickedPoint={clickedPoint}
        setClickedPoint={setClickedPoint}
      />
      <div className="mt-4">
        <div className="form-body">
          <div className="registration__form--body" style={{}}>
            {/* Incident Creation Date Info */}
            {/* {selectedIncidentInfo && (
                            <div className="alert alert-info mt-2">
                                <small>
                                    <strong>📅 Incident Created On:</strong> {new Date(selectedIncidentInfo.created_on).toLocaleString()}
                                    <br />
                                    <strong>🚨 Incident Name:</strong> {selectedIncidentInfo.name}
                                </small>
                            </div>
                        )} */}

            <form
              onSubmit={handleSubmit(submitHandler)}
              name="MasterResourceRegForm"
              encType="multipart/form-data"
            >
              <div>
                {tabsData?.map((tab) => (
                  <>
                    {tab.id === activeTab && (
                      <>
                        <div className="registration__form--heading">
                          {tab.heading}
                        </div>
                        <div>{tab.component}</div>
                      </>
                    )}
                  </>
                ))}
              </div>

              <div className="d-flex justify-content-center">
                {tabsData.length - 1 === activeTab && (
                  <Button
                    type="submit"
                    className="mx-2"
                    variant="primary"
                    style={{ marginBottom: "8px" }}
                    disabled={isSubmitting || loader}
                  >
                    {isSubmitting
                      ? "Submitting..."
                      : edit
                      ? "Update"
                      : t("Save & Submit")}
                  </Button>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateEventFormPage;
